var render = function render(){var _vm=this,_c=_vm._self._c;return _c('week-view-grid',{attrs:{"headers":_vm.headers,"items":_vm.facilitiesBookings},scopedSlots:_vm._u([{key:"information-card",fn:function({ data }){return [_c('div',{staticClass:"py-2 pl-1 d-flex justify-space-between flex-column",style:({
        height: '100%',
        width: '100%',
        backgroundColor: '#F1F8E9',
      })},[_c('span',{style:({ fontSize: _vm.namesFontSize })},[_vm._v(" "+_vm._s(data.name)+" ")]),_c('span',{staticClass:"grey--text text--darken-2",style:({ fontSize: _vm.departmentsFontSize })},[_vm._v(" "+_vm._s(_vm.facilityDepartments(data.departments))+" ")])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }